module.exports = __webpack_public_path__ + "static/mtb-p-4-02b65d3c65a2a652ae3e71ec2f1d81eb.png";